import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { clearNotification } from '../../../ducks/cart.duck';
import { Notification } from '../../../components';

const NotificationContainer = () => {
  const dispatch = useDispatch();
  const notification = useSelector(state => state.cart.notification);

  useEffect(() => {
    if (notification) {
      // Auto-clear notification after appropriate duration
      const duration = notification.type === 'error' ? 5000 : 3000;
      const timer = setTimeout(() => {
        dispatch(clearNotification());
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [notification, dispatch]);

  if (!notification) return null;

  // Handle both old string format and new object format for backward compatibility
  const message = typeof notification === 'string' ? notification : notification.message;
  const type = typeof notification === 'string' ? 'info' : (notification.type || 'info');

  return (
    <Notification
      message={message}
      type={type}
      duration={type === 'error' ? 5000 : 3000}
    />
  );
};

export default NotificationContainer;

